export default __webpack_public_path__ + "static/media/icon_arrow_right.3376a595.svg";